import React from 'react';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import Config from '@go-client/lib/config';
import { BubbleButton } from '@go-client/components/BubbleUI';
import { exportBrandSettings } from '@go-client/lib/api/brand';

async function downloadBrandSettings(id: string) {
  const result = await exportBrandSettings(id);

  if (result.location) window.open(result.location, '_blank');
}

export default function ServerAtAGlance() {
  const { brand, plugins } = useServerInfo();

  let infoToShow = [
    {
      key: 'go-version',
      label: 'GO Version',
      value: <span>{Config.VERSION}</span>,
    },
    {
      key: 'enabled-plugins',
      label: 'Enabled Plugins',
      value: <span>{plugins.map(p => p.name).join(', ')}</span>,
    },
  ];

  infoToShow = infoToShow.concat(
    (brand.settings?.notes ?? []).map(bb => {
      return {
        key: bb._id,
        label: bb.label,
        value: bb.value.match(/^https?:\/\/.*$/) ? (
          <a className="underline text-navy" href={`${bb.value}`} target="_blank">
            {bb.value}
          </a>
        ) : (
          <span>{bb.value}</span>
        ),
      };
    })
  );

  return (
    <>
      <table className="w-full shadow-sm mb-5">
        <tbody>
          {infoToShow.map((info, i) => (
            <tr key={info.key} className={`${i % 2 !== 0 ? 'bg-eggshell-dark' : 'bg-white'}`}>
              <td className="py-2 pl-5 pr-2 font-bold align-top w-1/3">{info.label}:</td>
              <td className="py-2 pl-5 align-top">{info.value}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <BubbleButton
        className="text-left"
        icon="file-export"
        variant="navy"
        onClick={() => downloadBrandSettings(brand._id)}
      >
        Download Brand settings
      </BubbleButton>
    </>
  );
}
